var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCarbonMini = function SvgCarbonMini(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#F5B90D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#222",
    d: "M17.827 10.1q.04-.248.04-.5a3.867 3.867 0 0 0-7.08-2.147A2.667 2.667 0 0 0 7.334 9.76a3.06 3.06 0 0 0 .24 6.107H8.86a3.825 3.825 0 0 0 6.227 0h1.287A3.06 3.06 0 0 0 17.8 10.1zM16.4 14.527h-1.647a.67.67 0 0 0-.573.333 2.506 2.506 0 0 1-4.36 0 .67.67 0 0 0-.573-.333H7.6a1.734 1.734 0 1 1 .867-3.234.667.667 0 1 0 .666-1.153 3 3 0 0 0-.46-.213 1.333 1.333 0 0 1 2.04-1.054.7.7 0 0 0 .554.074.67.67 0 0 0 .413-.367 2.533 2.533 0 0 1 4.854 1.013q.003.074 0 .147h-.12q-.259 0-.514.04a.667.667 0 0 0 .22 1.313q.147-.009.293 0a1.733 1.733 0 1 1 0 3.467z"
  })));
};
export default SvgCarbonMini;